module.exports = __webpack_public_path__ + "img/Basketball.88b90dbe.png";